module.exports = ".container {\n  padding: 1em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.scss
// module id = ./src/app/dashboard/dashboard.component.scss
// module chunks = main